/* Mobau Pro – Bedarfsrechner der Produktseite (13.10.2026).
   Quelle dieser Datei: bestand/shopify_rechner.js → Theme-Asset assets/mobau-rechner.js (1:1 hochladen).
   Die Rechenvorschrift je Variante kommt aus dem Metafeld mobau.rechner (shopify_rechner.py). Sie wird dort aus der
   Mengenrechnung des KI-Chats abgeleitet und vor dem Schreiben gegen den Chat geprüft; rechne() unten ist dieselbe
   Formel wie shopify_rechner.rechne() (tests/test_shopify_rechner.py prüft beide gegeneinander, auch mit node).
   Typen: flaeche (m² je Verkaufseinheit bzw. Stück je m²), m2 (Preis je m²), reichweite (m² je Gebinde bei
   1 Anstrich/1 Schicht, optional Fliesenformat), schicht (m² × mm je Gebinde), laenge (m je Stück), meter (Preis je m).
   Keine Preise im Metafeld; der Preis im Ergebnis kommt aus den Variantendaten der Seite. */
(function () {
  'use strict';

  function rechne(spec, e) {
    var menge = e && e.menge;
    if (!spec || !(menge > 0)) return null;
    var w = e.verschnitt == null ? (spec.verschnitt || 0) : +e.verschnitt;
    var k = spec.anstriche ? (e.anstriche == null ? spec.anstriche : +e.anstriche) : 1;
    switch (spec.typ) {
      case 'flaeche':
        if (spec.stk_m2) return Math.ceil(menge * (1 + w / 100) * spec.stk_m2 - 1e-9);
        return Math.ceil(menge * (1 + w / 100) / spec.je - 1e-9);
      case 'm2':
        return Math.ceil(menge * (1 + w / 100) - 1e-9);
      case 'reichweite': {
        var je = spec.je;
        if (spec.formate && e.format) for (var i = 0; i < spec.formate.length; i++) if (spec.formate[i].k === e.format) je = spec.formate[i].je;
        return Math.ceil(menge * k / je - 1e-9);
      }
      case 'schicht': {
        var mm = e.mm;
        if (!(mm > 0)) return null;
        if ((spec.mm_min && mm < spec.mm_min) || (spec.mm_max && mm > spec.mm_max)) return null;
        return Math.ceil(menge * mm / spec.je - 1e-9);
      }
      case 'laenge':
        return Math.ceil(menge * (1 + w / 100) / spec.je - 1e-9);
      case 'meter': {
        var bedarf = menge * (1 + w / 100);
        if (spec.stueck) {
          var n = Math.ceil(bedarf / spec.stueck - 1e-9), ganz = n * spec.stueck;
          if (Math.abs(ganz - Math.round(ganz)) < 1e-6) return Math.round(ganz);
        }
        return Math.ceil(bedarf - 1e-9);
      }
    }
    return null;
  }
  var KERN = { rechne: rechne };
  if (typeof module === 'object' && module.exports) { module.exports = KERN; return; }
  if (window.MobauRechner) return;
  window.MobauRechner = KERN;

  /* =========================================================== Browser ===================================== */
  var root = document.querySelector('[data-mb-rechner]');
  if (!root) return;
  var pid = root.getAttribute('data-pid');
  var specs = {}, varianten = [];
  try { specs = JSON.parse(root.querySelector('[data-mb-rechner-daten]').textContent) || {}; } catch (e) {}
  try { varianten = JSON.parse(document.getElementById('mpdp-data-' + pid).textContent) || []; } catch (e) {}
  function variante(id) { for (var i = 0; i < varianten.length; i++) if (String(varianten[i].id) === String(id)) return varianten[i]; return null; }
  var idInput = document.querySelector('#AddToCartForm [data-variant-id]');
  var cur = variante(idInput && idInput.value) || varianten[0] || null;
  var spec = null, letzte = null;
  var zustand = { menge: '', l: '', b: '', lxb: false, verschnitt: null, anstriche: null, mm: '', format: '' };

  function zahl(x) { if (x == null) return NaN; var s = String(x).trim().replace(/\s/g, ''); if (/,/.test(s)) s = s.replace(/\./g, '').replace(',', '.'); return parseFloat(s); }
  function fmt(x, d) { return (Math.round(x * 1000) / 1000).toLocaleString('de-DE', { minimumFractionDigits: d || 0, maximumFractionDigits: 2 }); }
  function euro(c) { return (c / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function laenge() { return spec && (spec.typ === 'laenge' || spec.typ === 'meter'); }
  function einheit(n) {
    if (!cur) return '';
    if (cur.pe) return cur.pe;
    var e1 = cur.e1 || 'Stück', en = cur.en || 'Stück';
    if (e1 === 'Stück' && spec && (spec.typ === 'reichweite' || spec.typ === 'schicht')) { e1 = 'Gebinde'; en = 'Gebinde'; }
    return n === 1 ? e1 : en;
  }
  function einheit1() { return einheit(1); }

  var ICON = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><rect x="4" y="3" width="16" height="18" rx="2.5" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M8 7h8M8 11.5h1.5M11.25 11.5h1.5M14.5 11.5H16M8 15h1.5M11.25 15h1.5M8 18h1.5M11.25 18h1.5M15.25 15v3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';

  function feld(id, label, inner) { return '<div class="mb-rech__feld"><label for="' + id + '">' + label + '</label>' + inner + '</div>'; }
  function eingabe(id, wert, einheitTxt, attr) {
    return '<div class="mb-rech__eingabe"><input id="' + id + '" type="text" inputmode="decimal" autocomplete="off" value="' + esc(wert) + '" ' + (attr || '') + '><span>' + einheitTxt + '</span></div>';
  }
  function auswahl(id, attr, optionen, gewaehlt) {
    return '<select id="' + id + '" ' + attr + '>' + optionen.map(function (o) {
      return '<option value="' + esc(o[0]) + '"' + (String(o[0]) === String(gewaehlt) ? ' selected' : '') + '>' + esc(o[1]) + '</option>';
    }).join('') + '</select>';
  }

  function aufbauen() {
    var t = spec.typ, id = 'mb-rech-' + pid, h = [];
    var farbe = spec.wort === 'Anstriche';
    var titel = farbe ? 'Wie viel Farbe brauchen Sie?' : 'Wie viel brauchen Sie?';
    var unter = laenge() ? 'Länge eingeben – wir rechnen die Menge aus.' : t === 'schicht' ? 'Fläche und Schichtdicke eingeben – wir rechnen die Gebinde aus.'
      : 'Fläche eingeben – wir rechnen die Menge aus.';
    h.push('<div class="mb-rech__kopf">' + ICON + '<div><strong class="mb-rech__titel">' + titel + '</strong><span class="mb-rech__unter">' + unter + '</span></div></div>');
    var felder = [];
    if (laenge()) {
      felder.push(feld(id + '-m', 'Länge', eingabe(id + '-m', zustand.menge, 'm', 'data-r="menge" placeholder="z. B. 12,5"')));
    } else {
      felder.push(feld(id + '-m', 'Fläche', eingabe(id + '-m', zustand.menge, 'm²', 'data-r="menge" placeholder="z. B. 12,5"')));
    }
    if (t === 'flaeche' || t === 'm2' || t === 'laenge' || t === 'meter') {
      var v0 = zustand.verschnitt == null ? (spec.verschnitt || 0) : zustand.verschnitt;
      felder.push(feld(id + '-v', laenge() ? 'Zuschlag' : 'Verschnitt', auswahl(id + '-v', 'data-r="verschnitt"',
        [[0, 'ohne'], [5, '+ 5 %'], [10, '+ 10 %'], [15, '+ 15 %']], v0)));
    }
    if (t === 'reichweite' && spec.anstriche) {
      var stufen = spec.wort === 'Schichten' ? [2, 3] : [1, 2, 3];
      var k0 = zustand.anstriche == null ? spec.anstriche : zustand.anstriche;
      felder.push(feld(id + '-k', spec.wort, auswahl(id + '-k', 'data-r="anstriche"', stufen.map(function (k) {
        return [k, k + ' ' + (k === 1 ? (spec.wort === 'Schichten' ? 'Schicht' : 'Anstrich') : spec.wort)]; }), k0)));
    }
    if (t === 'reichweite' && spec.formate) {
      felder.push(feld(id + '-f', 'Fliesenformat <span class="mb-rech__klein">(längste Kante)</span>', auswahl(id + '-f', 'data-r="format"',
        [['', 'ohne Angabe']].concat(spec.formate.map(function (f) { return [f.k, f.t]; })), zustand.format)));
    }
    if (t === 'schicht') {
      var ph = spec.mm_min && spec.mm_max ? fmt(spec.mm_min) + '–' + fmt(spec.mm_max) : spec.mm_max ? 'bis ' + fmt(spec.mm_max) : spec.mm_min ? 'ab ' + fmt(spec.mm_min) : 'z. B. 10';
      felder.push(feld(id + '-d', 'Schichtdicke', eingabe(id + '-d', zustand.mm, 'mm', 'data-r="mm" placeholder="' + esc(ph) + '"')));
    }
    h.push('<div class="mb-rech__felder">' + felder.join('') + '</div>');
    if (!laenge()) {
      h.push('<button type="button" class="mb-rech__lxb" data-r-lxb aria-expanded="' + (zustand.lxb ? 'true' : 'false') + '">' + (zustand.lxb ? 'Fläche direkt eingeben' : 'Fläche aus Länge × Breite berechnen') + '</button>');
      h.push('<div class="mb-rech__felder mb-rech__felder--lxb"' + (zustand.lxb ? '' : ' hidden') + '>' +
        feld(id + '-l', 'Länge', eingabe(id + '-l', zustand.l, 'm', 'data-r="l"')) +
        feld(id + '-b', farbe ? 'Höhe' : 'Breite', eingabe(id + '-b', zustand.b, 'm', 'data-r="b"')) + '</div>');
    }
    h.push('<div class="mb-rech__ergebnis" data-r-ergebnis aria-live="polite" hidden><p class="mb-rech__menge" data-r-menge></p><p class="mb-rech__detail" data-r-detail></p>' +
      '<p class="mb-rech__warn" data-r-warn hidden></p><button type="button" class="mb-rech__ok" data-r-ok>Menge übernehmen</button></div>');
    var quelle = spec.richtwert ? 'Richtwert' : spec.quelle || '';
    var basis = spec.basis || '';
    if (spec.formate && zustand.format) spec.formate.forEach(function (f) { if (f.k === zustand.format) { basis = f.basis || basis; if (f.richtwert) quelle = 'Richtwert'; } });
    h.push('<p class="mb-rech__grund" data-r-grund>' + (quelle === 'Richtwert' ? '<span class="mb-rech__marke">Richtwert</span> ' : '') +
      (basis ? 'Grundlage: ' + esc(basis) + (quelle && quelle !== 'Richtwert' ? ' (' + esc(quelle) + ')' : '') + '. ' : '') +
      esc(spec.hinweis || (laenge() ? 'Der Zuschlag für Verschnitt und Gehrung ist ein Faustwert.' : t === 'flaeche' || t === 'm2' ? 'Verschnitt ist ein Faustwert – bei vielen Ecken oder Diagonalverlegung eher mehr einplanen.' : '')) + '</p>');
    root.innerHTML = h.join('');
    root.hidden = false;
    rechnen();
  }

  function eingaben() {
    var e = { menge: zahl(zustand.menge) };
    if (zustand.lxb && !laenge()) {
      var l = zahl(zustand.l), b = zahl(zustand.b);
      e.menge = l > 0 && b > 0 ? Math.round(l * b * 100) / 100 : NaN;
    }
    e.verschnitt = zustand.verschnitt == null ? (spec.verschnitt || 0) : +zustand.verschnitt;
    if (spec.anstriche) e.anstriche = zustand.anstriche == null ? spec.anstriche : +zustand.anstriche;
    e.format = zustand.format || '';
    e.mm = zahl(zustand.mm);
    return e;
  }

  function detailText(e, n) {
    var t = spec.typ, w = e.verschnitt || 0, teile = [];
    var basis = laenge() ? fmt(e.menge) + ' m' : fmt(e.menge) + ' m²';
    if (t === 'flaeche' || t === 'm2' || t === 'laenge' || t === 'meter') {
      teile.push(w ? basis + ' + ' + w + ' % = ' + fmt(e.menge * (1 + w / 100)) + (laenge() ? ' m' : ' m²') : basis);
      if (t === 'flaeche') teile.push(spec.stk_m2 ? fmt(spec.stk_m2) + ' Stück je m²' : fmt(spec.je) + ' m² je ' + einheit1() + ' → ' + fmt(n * spec.je) + ' m²');
      if (t === 'laenge') teile.push(fmt(spec.je) + ' m je ' + einheit1() + ' → ' + fmt(n * spec.je) + ' m');
      if (t === 'meter' && spec.stueck) teile.push(fmt(spec.stueck) + ' m je Stück');
    } else if (t === 'reichweite') {
      var je = spec.je;
      if (spec.formate && e.format) spec.formate.forEach(function (f) { if (f.k === e.format) je = f.je; });
      var k = e.anstriche || 1;
      teile.push(k > 1 ? basis + ' × ' + k + ' ' + spec.wort + ' = ' + fmt(e.menge * k) + ' m²' : basis);
      teile.push('reicht je ' + einheit1() + ' für ca. ' + fmt(je) + ' m²' + (spec.anstriche ? (spec.wort === 'Schichten' ? ' (eine Schicht)' : ' (ein Anstrich)') : ''));
    } else if (t === 'schicht') {
      teile.push(basis + ' × ' + fmt(e.mm) + ' mm');
      teile.push('reicht je ' + einheit1() + ' für ca. ' + fmt(spec.je / e.mm) + ' m² bei ' + fmt(e.mm) + ' mm');
    }
    return teile.join(' · ');
  }

  function rechnen() {
    var box = root.querySelector('[data-r-ergebnis]'); if (!box) return;
    var warn = box.querySelector('[data-r-warn]'), ok = box.querySelector('[data-r-ok]');
    var e = eingaben(), n = null;
    letzte = null;
    if (!(e.menge > 0) || e.menge > 100000) { box.hidden = true; return; }
    if (spec.typ === 'schicht') {
      if (!(e.mm > 0)) { box.hidden = true; return; }
      if ((spec.mm_min && e.mm < spec.mm_min) || (spec.mm_max && e.mm > spec.mm_max)) {
        box.hidden = false; ok.hidden = true; warn.hidden = true;
        box.querySelector('[data-r-menge]').textContent = 'Der Hersteller nennt für dieses Produkt eine Schichtdicke ' +
          (spec.mm_min && spec.mm_max ? 'von ' + fmt(spec.mm_min) + ' bis ' + fmt(spec.mm_max) + ' mm' : spec.mm_max ? 'bis ' + fmt(spec.mm_max) + ' mm' : 'ab ' + fmt(spec.mm_min) + ' mm') + '.';
        box.querySelector('[data-r-detail]').textContent = 'Für ' + fmt(e.mm) + ' mm ist es nicht gedacht – bitte wählen Sie ein passendes Produkt.';
        return;
      }
    }
    n = rechne(spec, e);
    if (!n) { box.hidden = true; return; }
    letzte = n;
    var preis = cur && cur.pc ? ' <span class="mb-rech__preis">≈ ' + euro(cur.pc * n) + '</span>' : '';
    box.querySelector('[data-r-menge]').innerHTML = 'Sie benötigen <strong>' + n.toLocaleString('de-DE') + ' ' + esc(einheit(n)) + '</strong>' + preis;
    box.querySelector('[data-r-detail]').textContent = detailText(e, n);
    var w = '';
    if (!cur || !cur.a) w = 'Diese Ausführung ist derzeit nicht vorrätig.';
    else if (cur.inv !== null && cur.deny && n > cur.inv) w = 'Online verfügbar sind derzeit ' + cur.inv.toLocaleString('de-DE') + ' ' + einheit(cur.inv) + '. Für größere Mengen rufen Sie uns bitte an: 02451 4834-0.';
    warn.textContent = w; warn.hidden = !w;
    ok.hidden = !cur || !cur.a;
    ok.textContent = 'Menge übernehmen';
    box.hidden = false;
  }

  /* Menge ins Kaufformular: Mengenfeld setzen und die vorhandenen Regeln wirken lassen (Bestandsgrenze aus
     mobau-pdp-script, ganze Zentrallager-Gebinde aus mobau-zentrallager.js) – danach zeigen, was wirklich steht. */
  function uebernehmen() {
    if (!letzte || !cur) return;
    var qty = document.querySelector('#AddToCartForm [data-qty-input]'); if (!qty) return;
    var wunsch = letzte, gesetzt = wunsch, rolle = document.querySelector('.mpdp-is-rolle [data-roll]:not([hidden]) [data-roll-len]');
    if (rolle && spec.typ === 'm2') {
      var bw = zahl((document.querySelector('[data-roll-w]') || {}).textContent);
      var step = [0.5, 1, 2.5, 5, 10].filter(function (x) { return Math.abs(bw * x - Math.round(bw * x)) < 1e-9; })[0] || 1;
      var len = Math.ceil(wunsch / bw / step - 1e-9) * step;
      rolle.value = String(len).replace('.', ',');
      rolle.dispatchEvent(new Event('change', { bubbles: true }));
      gesetzt = parseInt(qty.value, 10) || 0;
    } else {
      if (qty.max && +qty.max > 0 && wunsch > +qty.max) gesetzt = +qty.max;
      qty.value = gesetzt;
      qty.dispatchEvent(new Event('change', { bubbles: true }));
      qty.dispatchEvent(new Event('input', { bubbles: true }));
      gesetzt = parseInt(qty.value, 10) || gesetzt;
    }
    var b = root.querySelector('[data-r-ok]'), warn = root.querySelector('[data-r-warn]');
    b.textContent = '✓ ' + gesetzt.toLocaleString('de-DE') + ' ' + einheit(gesetzt) + ' übernommen';
    if (gesetzt < wunsch) {
      warn.textContent = 'Übernommen: ' + gesetzt.toLocaleString('de-DE') + ' ' + einheit(gesetzt) + ' – mehr ist online derzeit nicht verfügbar. Für die fehlenden ' +
        (wunsch - gesetzt).toLocaleString('de-DE') + ' ' + einheit(wunsch - gesetzt) + ' rufen Sie uns bitte an: 02451 4834-0.';
      warn.hidden = false;
    }
    setTimeout(function () { if (b.isConnected) b.textContent = 'Menge übernehmen'; }, 2600);
    var atc = document.querySelector('[data-atc]');
    if (atc) { var r = atc.getBoundingClientRect(); if (r.top < 0 || r.bottom > window.innerHeight) atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  }

  root.addEventListener('input', function (e) {
    var k = e.target.getAttribute('data-r'); if (!k) return;
    zustand[k] = e.target.value;
    rechnen();
  });
  root.addEventListener('change', function (e) {
    var k = e.target.getAttribute('data-r'); if (!k) return;
    zustand[k] = e.target.value;
    if (k === 'format') { aufbauen(); var f = root.querySelector('[data-r="format"]'); if (f) f.focus(); return; }
    rechnen();
  });
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-r-ok]')) { uebernehmen(); return; }
    var x = e.target.closest('[data-r-lxb]');
    if (x) {
      if (zustand.lxb) {
        var l = zahl(zustand.l), b = zahl(zustand.b);
        if (l > 0 && b > 0) zustand.menge = fmt(Math.round(l * b * 100) / 100);
      }
      zustand.lxb = !zustand.lxb;
      aufbauen();
      var fo = root.querySelector(zustand.lxb ? '[data-r="l"]' : '[data-r="menge"]'); if (fo) fo.focus();
    }
  });
  function wechseln(v) {
    cur = v || cur;
    var neu = cur ? specs[String(cur.id)] : null;
    if (!neu) { spec = null; root.hidden = true; root.innerHTML = ''; return; }
    var gleich = spec && spec.typ === neu.typ;
    spec = neu;
    if (!gleich) { zustand.verschnitt = null; zustand.anstriche = null; zustand.format = ''; }
    aufbauen();
  }
  document.addEventListener('variant:changed', function (e) { wechseln(e.detail && e.detail.variantData); });
  wechseln(cur);
})();
